export default {
	colors: {
		'primary-lima': '#dceb00',
		'primary-pink': '#dba89b',
		'secondary-lima': '#cdd72b',
		'secondary-pink': '#ddd9d2',
		'gray-1': '#424b5a',
		'gray-2': '#8994a5',
		'gray-3': '#bec9da',
		'gray-4': '#eeeeee',
		'gray-5': '#f7f7f7',
		'gray-6': '#d8d8d8',
		white: '#ffffff',
		black: '#000',
		success: '#7ed67a',
		error: '#f56e6e',
		warning: '#ffc108'
	}
}
